// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__198Bx","bigColWidth":"Table_bigColWidth__pnDPI","biggerColWidth":"Table_biggerColWidth__1m9e0","row":"Table_row__5DAC5","col":"Table_col__1s5Cy"};